"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyNowLoader = void 0;
const scriptLibraryLoader_1 = require("../../../core/library/loader/scriptLibraryLoader");
const constants_1 = require("./constants");
class VerifyNowLoader extends scriptLibraryLoader_1.ScriptLibraryLoader {
    constructor(verifyNowUrl) {
        super('VerifyNow', constants_1.LOAD_CONFIG);
        this.verifyNowUrl = verifyNowUrl;
    }
    getUrls() {
        return [this.verifyNowUrl];
    }
}
exports.VerifyNowLoader = VerifyNowLoader;
//# sourceMappingURL=index.js.map